export enum AsyncTaskStatus {
  EXECUTING = 'EXECUTING',
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED'
}

export interface AsyncTaskResponse {
  task_request_id: string;
}

export interface AsyncTaskStatusResponse<SuccessData extends object = object> {
  task_flow_id: string;
  task_status: AsyncTaskStatus;
  error_message?: string;
  success_data?: SuccessData;
}
